"use client";

/**
 * Prefer-over host for DialKit vendor controls outside DialRoot.
 * Vendor styles.css scopes tokens to `.dialkit-root` — without this host,
 * tracks/toggles/etc. collapse or paint invisible in product FieldTypes.
 */

import { forwardRef, type HTMLAttributes, type ReactNode } from "react";
import { cn } from "../../../lib";
import "./dialkit-embedded-baseline.css";
import {
	DIALKIT_EMBEDDED_HOST_CLASS,
	useDialKitEmbeddedTheme,
} from "./use-dialkit-embedded-theme";

export interface DialKitEmbeddedHostProps
	extends Omit<HTMLAttributes<HTMLDivElement>, "children"> {
	children: ReactNode;
}

export const DialKitEmbeddedHost = forwardRef<
	HTMLDivElement,
	DialKitEmbeddedHostProps
>(function DialKitEmbeddedHost({ children, className, ...rest }, ref) {
	const theme = useDialKitEmbeddedTheme();
	return (
		<div
			{...rest}
			ref={ref}
			className={cn(DIALKIT_EMBEDDED_HOST_CLASS, className)}
			data-theme={theme}
			data-dialkit-embedded-host="true"
		>
			{children}
		</div>
	);
});
